import type {ReactNode} from 'react'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {mutedCheckmarkIcon, checkmarkIcon, header, iconWrapper} from './success.module.scss'

type Props = {
  title: string
  muted?: boolean
  children?: ReactNode
}

export function Success(props: Props) {
  const {title, muted, children} = props
  const iconClassName = muted === true ? mutedCheckmarkIcon : checkmarkIcon
  return (
    <Container>
      <div className={header}>
        <div className={iconWrapper}>
          <FontAwesomeIcon className={iconClassName} icon={faCheckCircle} />
        </div>
        <div>
          <H2>{title}</H2>
          {children}
        </div>
      </div>
    </Container>
  )
}
